import { ofType } from "redux-observable";
import { concat, from, of } from "rxjs";
import { filter, mapTo, switchMap, take } from "rxjs/operators";
import { selectNotEnoughResourcesMissingResources } from "../../../selectors/selectNotEnoughResources";
import { actionModalOpen } from "../../modals/actionModal";
import { IdModal } from "../../modals/IdModal";
import { TypeActionNotEnoughResource, } from "../../not-enough-resource/actionNotEnoughResource";
import { IdMissingResourceTypes } from "../../not-enough-resource/IdMissingResourceTypes";
import { actionOngoingPurchaseStandardSelect } from "../../ongoing-purchase/actionOngoingPurchase";
import { actionStoreBuyPackageRequest, TypeActionStore, } from "../actionStore";
export var epicStoreBuyPackage = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionStore.BuyPackage), switchMap(function (action) {
        var state = state$.value;
        var cost = action.cost, amount = action.amount, packageId = action.packageId;
        var missingResources = selectNotEnoughResourcesMissingResources(state, cost);
        if (missingResources.length > 0) {
            return concat(from([
                actionOngoingPurchaseStandardSelect([
                    {
                        missingResources: missingResources,
                        missingType: IdMissingResourceTypes.Resources,
                    },
                ]),
                actionModalOpen(IdModal.NotEnoughResource),
            ]), action$.pipe(ofType(TypeActionNotEnoughResource.BuyWithGoldComplete), take(1), filter(function (notEnoughResourceAction$) {
                return notEnoughResourceAction$.isPurchased;
            }), mapTo(actionStoreBuyPackageRequest(packageId, amount, cost))));
        }
        return of(actionStoreBuyPackageRequest(packageId, amount, cost));
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/store/epics/epicStoreBuyPackage.ts
// module id = 2416
// module chunks = 3